/**
 * <vb-instagram> — arrows for the Instagram slider.
 *
 * The track scrolls natively (touch, trackpad, keyboard), so this only adds
 * the arrow buttons and keeps their state in sync. A custom element is used
 * rather than an inline script so it also works after the theme editor
 * re-renders the section.
 */
class VbInstagram extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.vb-ig__track');
    this.prev = this.querySelector('.vb-ig__arrow--prev');
    this.next = this.querySelector('.vb-ig__arrow--next');
    if (!this.track) return;

    this.update = this.update.bind(this);

    this.prev?.addEventListener('click', () => this.step(-1));
    this.next?.addEventListener('click', () => this.step(1));
    this.track.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);

    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
  }

  step(direction) {
    const tile = this.track.querySelector('.vb-ig__tile');
    if (!tile) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (tile.offsetWidth + gap), behavior: 'smooth' });
  }

  update() {
    // 2px of slack, because fractional widths never land exactly on the end
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    const atStart = this.track.scrollLeft <= 2;
    const atEnd = this.track.scrollLeft >= max;
    const scrollable = max > 0;

    this.toggleAttribute('data-static', !scrollable);
    if (this.prev) this.prev.disabled = atStart || !scrollable;
    if (this.next) this.next.disabled = atEnd || !scrollable;
  }
}

if (!customElements.get('vb-instagram')) {
  customElements.define('vb-instagram', VbInstagram);
}
